// extracted by mini-css-extract-plugin
export default {"inlineGiftAmountGroup":"gift-amount-select__inlineGiftAmountGroup__h7VCL"};